import { getStoredToken } from "@core/utils/auth";
import MainCard from "@mantis-theme/components/MainCard";
import { ThemeDirection } from "@mantis-theme/config";
import Grid from "@mui/material/Grid";
import Skeleton from "@mui/material/Skeleton";
import Stack from "@mui/material/Stack";
import { Theme } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import { jwtDecode } from "jwt-decode";
import { useEffect, useState } from "react";

interface JwtPayload {
  email: string;
  name: string;
  googleId: string;
  iat: number;
  exp: number;
}

export default function WelcomeCard() {
  const [userName, setUserName] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchUserData = () => {
      const token = getStoredToken();
      if (!token) {
        setError("No authentication token found");
        setIsLoading(false);
        return;
      }

      try {
        const decoded = jwtDecode<JwtPayload>(token);
        if (decoded?.name) {
          setUserName(decoded.name);
        } else {
          setError("User name not found in token");
        }
      } catch (error) {
        console.error("Error decoding token:", error);
        setError("Failed to decode user information");
      } finally {
        setIsLoading(false);
      }
    };

    fetchUserData();
  }, []);
  if (isLoading) {
    return (
      <MainCard
        border={false}
        sx={(theme: Theme) => ({
          background: `linear-gradient(250.38deg, ${theme.palette.primary.lighter} 2.39%, ${theme.palette.primary.light} 34.42%, ${theme.palette.primary.main} 60.95%, ${theme.palette.primary.dark} 84.83%, ${theme.palette.primary.darker} 104.37%)`,
          ...(theme.direction === ThemeDirection.RTL && {
            background: `linear-gradient(60.38deg, ${theme.palette.primary.lighter} 114%, ${theme.palette.primary.light} 34.42%, ${theme.palette.primary.main} 60.95%, ${theme.palette.primary.dark} 84.83%, ${theme.palette.primary.darker} 104.37%)`,
          }),
        })}
      >
        <Skeleton variant="rectangular" width="100%" height={150} />
      </MainCard>
    );
  }

  if (error) {
    return (
      <MainCard
        border={false}
        sx={(theme: Theme) => ({
          background: `linear-gradient(250.38deg, ${theme.palette.primary.lighter} 2.39%, ${theme.palette.primary.light} 34.42%, ${theme.palette.primary.main} 60.95%, ${theme.palette.primary.dark} 84.83%, ${theme.palette.primary.darker} 104.37%)`,
          ...(theme.direction === ThemeDirection.RTL && {
            background: `linear-gradient(60.38deg, ${theme.palette.primary.lighter} 114%, ${theme.palette.primary.light} 34.42%, ${theme.palette.primary.main} 60.95%, ${theme.palette.primary.dark} 84.83%, ${theme.palette.primary.darker} 104.37%)`,
          }),
        })}
      >
        <Typography color="error">{error}</Typography>
      </MainCard>
    );
  }

  return (
    <MainCard
      border={false}
      sx={(theme: Theme) => ({
        background: `linear-gradient(250.38deg, ${theme.palette.primary.lighter} 2.39%, ${theme.palette.primary.light} 34.42%, ${theme.palette.primary.main} 60.95%, ${theme.palette.primary.dark} 84.83%, ${theme.palette.primary.darker} 104.37%)`,
        ...(theme.direction === ThemeDirection.RTL && {
          background: `linear-gradient(60.38deg, ${theme.palette.primary.lighter} 114%, ${theme.palette.primary.light} 34.42%, ${theme.palette.primary.main} 60.95%, ${theme.palette.primary.dark} 84.83%, ${theme.palette.primary.darker} 104.37%)`,
        }),
      })}
    >
      <Grid container>
        <Grid size={{ md: 6, sm: 6, xs: 12 }}>
          <Stack
            sx={(theme) => ({
              gap: 2,
              padding: 3.4,
              color: "background.paper",
              ...theme.applyStyles("dark", { color: "text.primary" }),
            })}
          >
            <Typography variant="h2">
              {userName ? `Hello, ${userName}!` : "Welcome to Mantis"}
            </Typography>
            <Typography variant="h6">
              The purpose of a product update is to add new features, fix bugs
              or improve the performance of the product.
            </Typography>
            {/* <Box>
              <Button
                variant="outlined"
                color="secondary"
                sx={(theme) => ({
                  color: "background.paper",
                  borderColor: "background.paper",
                  ...theme.applyStyles("dark", {
                    color: "text.primary",
                    borderColor: "text.primary",
                  }),
                  "&:hover": {
                    color: "background.paper",
                    borderColor: "background.paper",
                    bgcolor: "primary.main",
                    ...theme.applyStyles("dark", {
                      color: "text.primary",
                      borderColor: "text.primary",
                      bgcolor: "primary.dark",
                    }),
                  },
                })}
                onClick={() => navigate("/trigger-push")}
              >
                Trigger Push
              </Button>
            </Box> */}
          </Stack>
        </Grid>
      </Grid>
    </MainCard>
  );
}
